export const ENVIRONMENT = (process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'local') as 'local' | 'production' | 'stage';
export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const STORAGE_URL = process.env.NEXT_PUBLIC_STORAGE_URL;
export const SITE_ID = process.env.NEXT_PUBLIC_SITE_ID;
export const APPLICATION_URL = process.env.NEXT_PUBLIC_APPLICATION_URL ?? '';
